function Access_control_form_group(element) {
    this.$element = $(element);
    
    this.init = function() {
		i4_Drag_drop.create({
			id_list_1: 'group_users_items',
			id_list_2: 'all_users_items'
		});
    };
}
